(function () {
  'use strict';

  function initStoreLocator(section) {
    if (!section || section.dataset.aslInitialized === 'true') return;
    section.dataset.aslInitialized = 'true';

    var tabs = section.querySelectorAll('[data-store-tab]');
    var panels = section.querySelectorAll('[data-store-panel]');
    var mapHost = section.querySelector('[data-store-map-host]');
    if (!mapHost || panels.length === 0) return;

    var switchStore = function (storeId) {
      panels.forEach(function (panel) {
        var isActive = panel.dataset.storePanel === storeId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.storeTab === storeId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var activePanel = section.querySelector('[data-store-panel="' + storeId + '"]');
      if (!activePanel) return;

      var mapTemplate = activePanel.querySelector('[data-store-map="' + storeId + '"]');
      if (!mapTemplate) return;

      mapHost.innerHTML = mapTemplate.innerHTML;
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchStore(tab.dataset.storeTab);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-avignaa-store-locator]').forEach(initStoreLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-avignaa-store-locator]');
    if (section) {
      delete section.dataset.aslInitialized;
      initStoreLocator(section);
    }
  });
})();
